import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import * as moment from 'moment';

import * as reducer from '@app/reducer';
import { isValid, preserveDateFromStringToMoment } from '@app/shared/common/helpers/time';

@Pipe({ name: 'momentFormat' })
export class MomentFormatPipe implements PipeTransform {

    private dateFormat: string;

    constructor(private store: Store<reducer.State>) {
        this.dateFormat =  reducer.getState(this.store).root.dateFormatShort;
     }

    transform(value: moment.MomentInput, format: string) {
        const invalidDate = 'Invalid date';
        const date = typeof value === 'string' ? preserveDateFromStringToMoment(value) : moment(value);
        const _isValid = isValid(value);
        const formattedDate = date ? date.format(format) : invalidDate;

        // DOTO: find more elegant way to check invalid dates
        return _isValid && formattedDate !== invalidDate ? formattedDate : value;
    }
}
